import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { ProfilePhotoComponent } from '@app/modules/profile/components/profile-photo/profile-photo.component'
import { SiteStore } from '@app/store/site.store'
import { ConversationStore } from '@messaging/components/store/conversation.store'
import { ButtonComponent } from '@ui/components/button/button.component'
import type { ConversationProfile } from '@messaging/models/conversation-profile.model'
import { IconComponent } from '@ui/components/icon/icon.component'

@Component({
  selector: 'sb-empty-conversation',
  imports: [ProfilePhotoComponent, IconComponent, ButtonComponent, RouterLink],
  templateUrl: './empty-conversation.component.html',
  styles: ':host { display: block }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyConversationComponent {
  readonly conversationStore = inject(ConversationStore)
  readonly siteStore = inject(SiteStore)

  readonly profile = input.required<ConversationProfile>()
}
